/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MUIDataTable from 'mui-datatables';
import Button from '@material-ui/core/Button';
import { TextField } from '@material-ui/core';
import { COLUMN, createProposalDetail, OPTIONS } from './utils';
import { ParcelClient, PlaceDetails } from '../../services/api';
import { AppContextType, useApp } from '../../context/AppContext';

const ProposalDetail = function (): JSX.Element {
  const { t } = useTranslation();

  const title = t('proposal_detail');
  const { id } = useParams();
  const { getParcelById, editParcelById } = ParcelClient();
  const { getPlaceDetails } = PlaceDetails();
  const { baggages } = useApp() as AppContextType;
  const [data, setData] = useState<any[]>([]);
  const [priceForShifters, setPriceForShifters] = React.useState<number>();
  const [recommendedPrice, setRecommendedPrice] = React.useState<number>();
  const [change, setChange] = useState(false);

  const COLUMN_TWO = [
    {
      name: 'name',
      label: '',
      options: {
        customHeadRender: ({index}) => (
          <th key={index} style={{ borderBottom: '0px solid rgba(224, 224, 224, 1)' }} />
        )
      }
    },
    {
      name: 'data',
      label: '',
      options: {
        customHeadRender: ({index}) => (
          <th key={index} style={{ borderBottom: '0px solid rgba(224, 224, 224, 1)' }} />
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;
          const isRow3 = rowIndex === 3;
          const isRow4 = rowIndex === 4;
          const isEditable = tableMeta.tableData[rowIndex][2] || tableMeta.tableData[rowIndex].isChanged;

          if ((isRow3 || isRow4) && isEditable) {
            const hasError = value === "" || value === null || value === undefined;

            return (
              <TextField
                value={value ?? ''}
                type="text"
                error={hasError}
                helperText={hasError ? t('required_field') : ''}
                onFocus={(event: any) => {
                  const valueTextField: any = event.nativeEvent.target.value.replace(/\D+/g, '');
                  updateValue(valueTextField);
                }}
                onChange={(event: any) => {
                  const val = event.target.value;
                  updateValue(val);
                  if (isRow4) {
                    setRecommendedPrice(val);
                  } else {
                    setPriceForShifters(val);
                  }
                }}
              />
            );
          }
          return <p>{value}</p>;
        }
      }
    },
    {
      name: 'isChanged',
      label: 'id',
      options: {
        display: false,
        viewColumns: false
      }
    }
  ];

  useEffect(() => {
    (async () => {
      const detailParcel = await getParcelById(parseInt(id, 10));
      const locationFrom = await getPlaceDetails(detailParcel.fromPlaceId ?? 'locationFrom');
      const locationTo = await getPlaceDetails(detailParcel.toPlaceId ?? 'locationTo');
      Promise.all([locationFrom, locationTo]).then(async (res) => {
        detailParcel.addressFrom = res[0].fullAddress;
        detailParcel.addressTo = res[1].fullAddress;
        const parcelDetail = createProposalDetail(detailParcel, baggages, t);
        detailParcel?.receiver && parcelDetail.push({
          name: t('number_phone_recipient'),
          data: detailParcel?.receiver?.phone
        })
        detailParcel?.receiver && parcelDetail.push({
          name: t('fio_recipient'),
          data: `${detailParcel?.receiver?.name ?? ''} ${detailParcel?.receiver?.surname}`.trim()
        });
        parcelDetail.push({
          name: t('payment'),
          data: detailParcel?.paymentStatus && detailParcel?.paymentStatus.includes('Paid') ?
                t('done') :
                t('not_done')
        });
        setData(parcelDetail);
      });
    })();
  }, [baggages, t]);

  const changeData = (value: boolean) => {
    const array = [...data];
    for (let index = 0; index < array.length; index++) {
      array[index].isChanged = value;
    }
    setData(array);
  };

  const saveChangedProposalDetail = async () => {
    if (recommendedPrice && priceForShifters) {
      const detail = await editParcelById(id, {recommendedPrice, priceForShifters});
      const locationFrom = getPlaceDetails(detail.locationFromPlaceId);
      const locationTo = getPlaceDetails(detail.locationToPlaceId);
      Promise.all([locationFrom, locationTo]).then((res) => {
        detail.addressFrom = res[0].fullAddress;
        detail.addressTo = res[1].fullAddress;
        const proposalDetail = createProposalDetail(detail, baggages, t);
        detail?.receiverInfo && proposalDetail.push({
          name:t('number_phone_recipient'),
          data:detail?.receiverInfo?.phoneNumber
        })
        detail?.receiverInfo && proposalDetail.push({
          name:t('fio_recipient'),
          data:detail?.receiverInfo?.fullName
        });
        proposalDetail.push({
          name: t('payment'),
          data:
          detail?.paymentStatus && detail?.paymentStatus.includes('Paid') ?
            t('done') :
            t('not_done')
        });
        setData(proposalDetail);
      });
      window.location.reload();
    }
  };
  const dataTableTwo = useMemo(
    () => (
      <MUIDataTable
        title={''}
        data={data.slice(8, data.length)}
        columns={COLUMN_TWO}
        options={OPTIONS(t)}
      />
    ),
    [data]
  );
  return (
    <React.Fragment>
      <h1 style={{ textAlign: 'center' }}>{title}</h1>
      <div style={{ display: 'flex', width: '100%', justifyContent: 'center', marginTop: '20px' }}>
        <div style={{ width: '40%', marginRight: '2%' }}>
          <MUIDataTable
            title={''}
            data={data.slice(0, 8)}
            columns={COLUMN()}
            options={OPTIONS(t)}
          />
        </div>
        <div style={{ width: '40%', marginLeft: '2%' }}>
         {dataTableTwo}
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
        <div style={{ margin: '5px' }}>
          <Button variant='outlined' onClick={() => {setChange(!change); changeData(!change)}}>
            {change ? t('cancel') : t('change')}
          </Button>
        </div>
        <div style={{ margin: '5px' }}>
          <Button variant='outlined' onClick={saveChangedProposalDetail}>
            {t('save')}
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProposalDetail;
